var map = {
	"./About_local.js": 594,
	"./Clause_local.js": 595,
	"./Detail_local.js": 596,
	"./Help_local.js": 597,
	"./Home_local.js": 598,
	"./News_local.js": 599,
	"./Product_local.js": 600,
	"./SitePage_local.js": 601,
	"./Tracking_local.js": 602,
	"./locale.js": 227
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 593;


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n ^\.\/.*\.js$
// module id = 593
// module chunks = 36